import { render } from "./SaleDocPaymentPref.vue?vue&type=template&id=eefd18d8&scoped=true"
import script from "./SaleDocPaymentPref.vue?vue&type=script&lang=js"
export * from "./SaleDocPaymentPref.vue?vue&type=script&lang=js"

import "./SaleDocPaymentPref.vue?vue&type=style&index=0&id=eefd18d8&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eefd18d8"]])

export default __exports__